import { PresentmentFilterPaylaod } from 'api/nach';
// import moment from 'moment';
import { createContext, useContext, useEffect, useState } from 'react';

interface FilterProps {
  filter?: PresentmentFilterPaylaod;
  setFilter?: any;
  reloadTabs?: boolean;
  setReloadTabs?: any;
  prevFilter?: string;
  setPrevFilter?: any;
  currentActiveTabKey: number;
  setCurrentActiveTabKey?: any;
}
const PresentmentFilterContext = createContext<FilterProps>({
  filter: { presentmentFlagId: undefined },
  currentActiveTabKey: 1,
  setCurrentActiveTabKey: () => { },
});

export const usePresentmentFilterContext = () => {
  return useContext(PresentmentFilterContext);
};

// "presentmentStatus": "COMPLETED",
// "presentmentStatus": "NOTIFICATION_IN_PROGRESS",
// "presentmentStatus": "NOTIFIED",
// "presentmentStatus": "PENDING",
// "presentmentStatus": "FAILED ",

interface Props {
  children: React.ReactNode;
}
const PresentmentFilterProvider = ({ children }: Props) => {
  const [filter, setFilter] = useState<PresentmentFilterPaylaod>();
  const [prevFilter, setPrevFilter] = useState<string>();
  const [currentActiveTabKey, setCurrentActiveTabKey] = useState(1);
  const [reloadTabs, setReloadTabs] = useState(false);
  useEffect(() => {
    console.log('current active tab', currentActiveTabKey);
  }, [currentActiveTabKey]);

  useEffect(() => {
    console.log('presentment filter form data----', prevFilter);
  }, [prevFilter]);
  return (
    <PresentmentFilterContext.Provider
      value={{
        filter,
        setFilter,
        reloadTabs,
        setReloadTabs,
        prevFilter,
        setPrevFilter,
        currentActiveTabKey,
        setCurrentActiveTabKey,
      }}
    >
      {children}
    </PresentmentFilterContext.Provider>
  );
};
export default PresentmentFilterProvider;
